<template>
    <div class="pixabay-search">
        <div class="pixabay-credit">
            <svg xmlns="http://www.w3.org/2000/svg" height="123.87" width="640" version="1.1" viewBox="0 0 640 123.87">
                <g transform="translate(-156.15726,-367.21451)" fill="#333">
                    <path d="m679.67,407.38c-3.4778-2.461-6.0048-4.9559-6.0048-8.0337h-19.338c0,5.5388-2.527,8.0337-5.6449,8.0337h-5.1644v56.236h100.42v-56.236h-64.629zm-6.0056,16.067-18.096,0,0-8.0337,20.084,0,0,6.4644zm33.991,31.276c-11.457,0-20.779-9.2018-20.779-20.513s9.3215-20.04,20.779-20.04c11.457,0,20.778,8.7283,20.778,20.04,0,11.311-9.3207,20.513-20.778,20.513zm11.17-20.513c0,6.0803-5.011,11.028-11.169,11.028-6.1591,0-11.17-4.9476-11.17-11.028,0-6.081,5.0109-11.027,11.17-11.027,6.1582,0,11.169,4.9468,11.169,11.027zm77.334-34.48-25.001,63.735-19.184-7.6934,0-10.862,13.323,5.4522,17.592-44.844-65.92-25.205-6.1099,19.034-11,0,11.248-32.135,85.053,32.519z"/>
                    <g style="word-spacing:0px;letter-spacing:0px;" font-family="VomZom" transform="matrix(4.129044,0,0,4.129044,-488.6229,-1536.6294)" font-style="normal" font-stretch="normal" font-size="23.68645096px" font-variant="normal" font-weight="normal" line-height="125%">
                        <path d="m164.38,467.99c4.011-0.0921,7.7758,3.1703,8.1995,7.17,0.50671,3.5153-1.5613,7.166-4.8022,8.5926-1.9632,0.97468-4.1802,0.67513-6.2919,0.72493h-2.063v6.6094h-3.2677c0.007-5.0998-0.0132-10.2,0.01-15.3,0.10696-3.7986,3.2179-7.2015,6.9739-7.7072,0.41065-0.061,0.82716-0.0908,1.2414-0.0901zm0,13.219c2.3572,0.0591,4.5679-1.78,4.9197-4.1152,0.46978-2.3507-1.0297-4.8765-3.3219-5.5815-2.214-0.78561-4.8777,0.24867-5.9588,2.3393-0.83901,1.4284-0.54099,3.1171-0.59666,4.691v2.6665c1.6526-0.00001,3.3051,0.00001,4.9577-0.00001z"/>
                        <path d="m174.16,467.91,3.2308,0,0,16.488-3.2308,0,0-16.488z"/>
                        <path d="m187.1,478.32,0.11776,0,4.5925,6.1234,4.0037,0-6.2411-8.4785,5.5346-8.0075-4.0038,0-3.886,5.6523-0.11776,0-3.886-5.6523-4.0037,0,5.5346,8.0075-6.2411,8.4785,4.0038,0z"/>
                        <path d="m203.13,467.91c3.2724-0.0646,6.4111,2.0792,7.6221,5.1058,0.63231,1.4057,0.62342,2.963,0.60314,4.472v6.91c-2.9161-0.01-5.8331,0.0201-8.7487-0.0157-3.3523-0.16361-6.4178-2.608-7.3775-5.8156-0.87984-2.7888-0.14884-6.0271,1.922-8.1097,1.5471-1.6003,3.7454-2.5681,5.9789-2.5468zm4.9576,13.22c-0.014-1.8333,0.0294-3.6684-0.0241-5.5004-0.19325-2.4562-2.4685-4.514-4.9336-4.4508-2.3436-0.0566-4.553,1.7616-4.9197,4.0819-0.42956,2.2266,0.84881,4.6528,2.9737,5.4838,1.3088,0.57081,2.7544,0.33544,4.1378,0.38549,0.92196,0.00001,1.8439,0.00001,2.7659,0.00001z"/>
                        <path d="m221.19,467.99c3.8699-0.0954,7.4862,2.9494,8.1024,6.7609,0.69922,3.6121-1.3415,7.5146-4.7051,9.0017-3.2872,1.5514-7.5139,0.55177-9.7744-2.2912-1.401-1.6503-2.0047-3.8445-1.8853-5.984v-14.097h3.2677v6.6094c1.6649,0.00021,3.3302-0.00043,4.9948,0.00032zm0,13.219c2.4818,0.0664,4.7507-2.0174,4.9325-4.4865,0.31135-2.4542-1.5078-4.9223-3.9368-5.3683-1.3432-0.18387-2.7076-0.0602-4.0606-0.0964h-1.9297c0.021,1.8627-0.0445,3.7289,0.0376,5.5892,0.25949,2.4609,2.485,4.4103,4.957,4.362z"/>
                        <path d="m238.9,467.91c3.2725-0.0646,6.411,2.0793,7.6222,5.1058,0.63229,1.4057,0.62343,2.963,0.60314,4.472v6.91c-2.9161-0.01-5.8331,0.0201-8.7487-0.0157-3.3523-0.16361-6.4178-2.608-7.3775-5.8156-0.87985-2.7888-0.14883-6.0271,1.922-8.1097,1.547-1.6003,3.7454-2.5681,5.9788-2.5468zm4.9576,13.22c-0.014-1.8333,0.0294-3.6684-0.0241-5.5004-0.19325-2.4562-2.4685-4.514-4.9336-4.4508-2.3436-0.0566-4.553,1.7616-4.9197,4.0819-0.42957,2.2266,0.84881,4.6528,2.9737,5.4838,1.3088,0.57081,2.7544,0.33544,4.1378,0.38549,0.92196,0.00001,1.8439,0.00001,2.7659,0.00001z"/>
                        <path d="m265.11,467.95c-0.007,5.0876,0.0132,10.176-0.0101,15.263-0.11859,4.004-3.5594,7.6027-7.5766,7.8119-0.7631,0.0404-1.5278,0.0158-2.2917,0.0226v-3.2677c1.3944-0.007,2.8862,0.13456,4.1212-0.65516,1.5426-0.86529,2.523-2.6105,2.4882-4.3753-2.8966,2.3356-7.3871,2.2143-10.204-0.19651-2.0523-1.6568-3.1738-4.322-3.0154-6.9447v-7.6578h3.2677c0.015,2.9107-0.0307,5.8234,0.0241,8.7328,0.17752,2.3961,2.314,4.4238,4.7151,4.4811,2.4332,0.18697,4.7752-1.7026,5.1382-4.1097,0.14646-1.44,0.0425-2.8946,0.0738-4.3411v-4.7632c1.0896-0.00007,2.1792-0.00014,3.2689-0.00021z"/>
                    </g>
                </g>
            </svg>
        </div>

        <app-input
            start-icon="search"
            v-model="args.query"
            :icon-clickable="true"
            @start-click="searchPixabay"
            @keydown.enter.prevent="searchPixabay"
            :disabled="search.searching"
            :loading="search.searching"
            :placeholder="placeholder">
        </app-input>

        <transition name="fade-left">
            <div v-if="search.totalHits === 0" class="pixabay-no-results" v-html="noResults"></div>
        </transition>

        <div ref="imagesWrap" :style="imagesWrapStyle"
             @scroll="handleScroll"
             id="pixabay-images"
             :class="{'loading': loadingSelectedImage}"
             class="pixabay-images">
            <div class="pixabay-loader" v-if="loadingSelectedImage"><div></div><div></div></div>
            <div class="pixabay-images-inner" v-if="search.hits && search.hits.length">
                <div class="pixabay-image-item"
                     :class="{'selected': args.selectedImage && args.selectedImage.id === image.id}"
                     @click="selectPixabayImg(image)"
                     :key="index" v-for="(image, index) in search.hits">
                    <div v-if="args.selectedImage && args.selectedImage.id === image.id" class="pixabay-selected-overlay"></div>
                    <img :src="selectedSrc" class="pixabay-image-selected"
                         v-if="args.selectedImage && args.selectedImage.id === image.id"/>
                    <img :src="image.webformatURL" alt=""/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {reactive, nextTick, ref, onMounted, computed, watch} from 'vue';
import {debounce} from 'lodash';

function readImageAsBase(url) {
    return new Promise((resolve, reject) => {
        fetch(url)
            .then( response => response.blob() )
            .then( blob => {
                const reader = new FileReader() ;
                reader.onload = function() {
                    resolve(this.result);
                };

                reader.readAsDataURL(blob) ;
            }) ;
    });
}

export default {
    emits: ['update:image', 'update:query'],

    props: {
        image: {
            type: String,
            default: ''
        },
        placeholder: String,
        query: String,
        noResults: String,
        perPage: {
            type: Number,
            default: 10
        }
    },

    setup(props, context) {
        const apiKey = window.app.keys.pixabay;
        const imagesWrap = ref(null);
        const loadingSelectedImage = ref(false);
        const selectedSrc = require('../../images/checkmark.png');
        const imagesWrapOffset = ref(0);

        const args = reactive({
            page: 1,
            complete: false,
            perPage: props.perPage,
            query: props.query && props.query.length ? props.query : '',
            selectedImage: null
        });

        const search = reactive({
            searching: false,
            hits: [],
            totalHits: null,
            total: null,
        });

        const baseUri = `https://pixabay.com/api/?key=${apiKey}&q={0}&page={1}&per_page=${props.perPage}`;
        const requestUri = computed(() => baseUri
            .replace('{0}', args.query)
            .replace('{1}', args.page));

        const selectPixabayImg = async (image) => {
            args.selectedImage = image;

            loadingSelectedImage.value = true;
            const imageBase = await readImageAsBase(image.fullHDURL ? image.fullHDURL : image.largeImageURL);
            loadingSelectedImage.value = false;
            context.emit('update:image', imageBase);
            context.emit('update:query', args.query);
        };
        const searchPixabay = async (loadMore = false) => {
            if (args.complete || search.searching) {
                return;
            }

            search.searching = true;

            if (loadMore) {
                args.page = args.page + 1;
            }

            const res = await fetch(requestUri.value);
            const json = await res.json();

            search.searching = false;

            if (! json.hits || ! json.hits.length) {
                if (args.page > 1) {
                    args.complete = true;
                } else {
                    search.totalHits = 0;
                }

                return;
            }

            if (json.hits.length) {
                search.hits = [...search.hits, ...json.hits];
                search.totalHits = json.totalHits;
                search.total = json.total;
            }
        };

        const handleScroll = (el) => {
            if((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= (el.srcElement.scrollHeight - 100)) {
                if (args.complete || search.searching) {
                    return;
                }

                searchPixabay(true);
            }
        };

        const imagesWrapStyle = computed(() => {
            if (! imagesWrapOffset.value) {
                return {};
            }

            return {
                maxHeight: `calc(100vh - ${imagesWrapOffset.value.y + 133}px)`,
            }
        })

        watch(args, () => {
            context.emit('update:image', '');
        });

        onMounted(() => {
            nextTick(() => {
                if (args.query) {
                    searchPixabay();
                }

                imagesWrapOffset.value = imagesWrap.value.getBoundingClientRect();
            })
        });

        return {
            imagesWrap,
            args,
            search,
            selectedSrc,
            imagesWrapStyle,
            imagesWrapOffset,
            loadingSelectedImage,
            selectPixabayImg,
            handleScroll,
            searchPixabay: debounce(async () => {
                if (args.query.length < 3) {
                    search.hits = [];
                    search.searching = false;
                    return;
                }

                search.hits = [];
                search.totalHits = null;
                args.page = 1;
                args.complete = false;

                await searchPixabay();
            }, 10)
        }
    }
}
</script>
